<!-- 病史信息 -->
<template>
  <div class="medicalHistoryInfo">
    <!-- 详情部分 -->
    <div>
      <div class="editTxt" @click="add" v-if="!params.mode">
        {{ data.historyInfoList.length > 0 ? '编辑' : '添加' }}
      </div>
      <div class="info" v-if="data.historyInfoList.length > 0">
        <div
          v-for="(item, index) in data.historyInfoList"
          :key="index"
          style="margin-bottom: 15.5px"
        >
          <span class="infoName">{{ item.name }}</span>
          <div v-if="infoShowIf(item)">
            <div v-if="item.chooseValues[0] !== '无' && item.chooseValues[0] !== ''">
              <a-tag v-for="(tagItem, tagIndex) in item.chooseValues" :key="tagIndex">
                {{ tagItem }}
              </a-tag>
            </div>
            <div v-if="item.textInfo.value">
              <a-textarea
                disabled
                style="width: 100%; margin-top: 10px"
                v-model:value="item.textInfo.value"
                autoSize
              />
            </div>
          </div>
          <div v-else>
            <div class="noDataTxt">— 无{{ item.name }} —</div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="z-fixed-c">
          <auth-img class="empty-img" src="@/assets/img/empty.png" />
        </div>
        <div class="z-fixed-c empty-txt">暂无数据</div>
      </div>
    </div>

    <!-- 弹窗部分 -->
    <a-drawer
      title="病史信息"
      placement="right"
      :closable="false"
      :width="726"
      :visible="data.visible"
      :body-style="{ paddingBottom: '80px' }"
    >
      <div class="center">
        <a-form :model="data.formState" ref="formRef">
          <div v-for="(item, index) in data.historyList" :key="index">
            <div class="name">{{ item.name }}</div>
            <a-form-item :name="item.key">
              <a-checkbox-group v-model:value="data.formState[item.key]" style="width: 100%">
                <a-row :gutter="[8, 10]">
                  <a-col :span="6" v-for="(cItem, cIndex) in item.children" :key="cIndex">
                    <a-checkbox
                      v-if="cItem.type !== 5"
                      :disabled="disabled(data.formState[item.key], cItem, item)"
                      :value="cItem.name"
                      :name="cItem.name"
                    >
                      {{ cItem.name }}
                    </a-checkbox>
                  </a-col>
                </a-row>
              </a-checkbox-group>
            </a-form-item>
            <div>
              <a-textarea
                :disabled="disabled(data.formState[item.key], item.children[1], item)"
                style="width: 100%; margin-top: 10px"
                v-model:value="data.formState[item.textInfo.name]"
                showCount
                :maxlength="100"
              />
            </div>
          </div>
        </a-form>
      </div>
      <div class="footer">
        <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
        <a-button type="primary" @click="onSubmit">保存</a-button>
      </div>
    </a-drawer>
  </div>
</template>

<script setup>
import { reactive, onMounted, ref, createVNode, defineProps } from 'vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { Modal, message } from 'ant-design-vue'
// import { historyList } from './config'
import { getDiseaseHistory, saveInfo, getHealthInfo } from '@/api/HealthRecord/index.js'
const props = defineProps({
  params: {
    type: Object,
    default: () => ({
      ucPatientId: null,
      mode: ''
    })
  }
})
const data = reactive({
  ucPatientId: props.params.ucPatientId, //患者id
  value: '',
  historyList: [],
  historyInfoList: [],
  visible: false,
  formState: {},
  formResult: {} //最后传给后端的数据
})
const formRef = ref()
const onSubmit = () => {
  //提交之后 把数据拼在题目里
  formResult().then(() => {
    const params = JSON.parse(JSON.stringify(data.formResult))
    for (const key in params) {
      params[key] = params[key] ? params[key] : ''
    }
    params.type = 2
    console.log('最终结果c传给后端字段===', params)
    saveInfo(params).then(() => {
      message.success('保存成功')
      getHistoryList()
      data.visible = false
    })
  })
}
//详情展示判断条件
const infoShowIf = item => {
  return (
    (item &&
      item.chooseValues &&
      item.chooseValues.length > 0 &&
      item.chooseValues[0] !== '无' &&
      item.chooseValues[0] !== '') ||
    item.textInfo.value
  )
}

//拼后端所需要的数据
const formResult = () => {
  return new Promise(resolve => {
    data.historyList.map(item => {
      item.textInfo.value = data.formState[item.textInfo.name]
      item.chooseValues = data.formState[item.key]
      data.formResult[item.key] =
        item && item.chooseValues
          ? item.chooseValues.length > 1
            ? item.chooseValues.join(',')
            : item.chooseValues[0]
            ? item.chooseValues[0]
            : ''
          : ''
      data.formResult[item.textInfo.name] = item.textInfo.value
      data.formResult.ucPatientId = data.ucPatientId
    })
    resolve()
  })
}

const add = () => {
  getBaseInfo()
  data.visible = true
}
const onClose = () => {
  Modal.confirm({
    centered: true,
    icon: createVNode(ExclamationCircleOutlined),
    title: () => '取消后无法保存，确定取消吗？',
    okText: () => '确定',
    cancelText: () => '取消',
    onOk() {
      data.visible = false
    },
    onCancel() {}
  })
}
// 初始化详情数据 和 formState数据
const initHistoryInfo = () => {
  const list = []
  data.historyList.map(item => {
    if ((item && item.chooseValues && item.chooseValues.length > 0) || item.textInfo.value) {
      data.formState[item.textInfo.name] = item.textInfo.value
      //初始化多选框的数据
      data.formState[item.key] = item.chooseValues
      // 初始化输入框的数据
    }
    list.push(item)
  })
  data.historyInfoList = JSON.parse(JSON.stringify(list))
}
const disabled = (fromKey, cItem, item) => {
  // 处理选择无的时候，不可以选择其他选项，当选择其他选项时不可以选择第一个无
  if ((fromKey && fromKey.length > 0) || data.formState[item.textInfo.name]) {
    if (
      (fromKey && fromKey[0] !== '无' && fromKey[0] !== '') ||
      data.formState[item.textInfo.name]
    ) {
      if (cItem.value == '无') {
        return true
      } else {
        return false
      }
    } else {
      // 空或者是 无
      //先判断是不是选择了无
      if (fromKey.includes('无')) {
        fromKey = ['无']
        if (cItem.value !== '无') {
          return true
        }
      }
    }
  } else {
    return false
  }

  //return true
}
const getHistoryList = () => {
  getDiseaseHistory({ ucPatientId: data.ucPatientId }).then(res => {
    data.historyList = res
    initHistoryInfo()
  })
}

const getBaseInfo = () => {
  getHealthInfo({ ucPatientId: data.ucPatientId }).then(res => {
    if (res.id) {
      data.formResult.id = res.id
    }
  })
}
onMounted(() => {
  getHistoryList()
  getBaseInfo()
})
</script>

<style scoped lang="scss">
.empty-img {
  margin-top: 80px;
}
.empty-txt {
  font-size: 14px;
  color: #999999;
  margin-top: 17px;
}
.medicalHistoryInfo {
  position: relative;
  padding: 0 20px;
  .info {
    padding: 15.5px 4px;
    ::v-deep(.ant-tag) {
      border: 2px solid rgba(51, 51, 51, 0.3);
      border-radius: 4px;
      padding: 6px 12px;
      line-height: 20px;
      margin-right: 44px;
      margin-top: 12px;
      font-size: 14px;
      color: #666666;
      background: #ffffff;
    }
    ::v-deep(.ant-input[disabled]) {
      background-color: #ffffff;
      font-size: 14px;
      color: #666666;
      border: 1px solid rgba(217, 217, 217, 0.3);
      border-radius: 4px;
      word-break: break-all;
    }
    .infoName {
      font-weight: bold;
      font-size: 16px;
      color: #333333;
      line-height: 24px;
    }
    .noDataTxt {
      font-size: 14px;
      color: #999999;
      margin-top: 12px;
    }
  }

  .editTxt {
    height: 32px;
    line-height: 32px;
    text-align: right;
    border-bottom: 1px solid #e8e8e8;
    color: #1890ff;
    cursor: pointer;
  }
  .center {
  }
}
.name {
  font-weight: bold;
  font-size: 16px;
  color: #333333;
  line-height: 24px;
  margin-bottom: 17px;
}
.footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}
</style>
